import { render } from "./userLostPassCode.vue?vue&type=template&id=77e8bb0a&scoped=true"
import script from "./userLostPassCode.vue?vue&type=script&lang=js"
export * from "./userLostPassCode.vue?vue&type=script&lang=js"

import "./userLostPassCode.vue?vue&type=style&index=0&id=77e8bb0a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e8bb0a"]])

export default __exports__